module.exports = __webpack_public_path__ + "img/image_cellmate_gen2_cg01.2bf79ee8.png";